import { IButtonStyles, concatStyleSets } from '@fluentui/react';
import {
  activeBackgroundColor,
  defaultBackgroundColor,
  defaultForegroundColor,
  hoverBackgroundColor,
  hoverForegroundColor,
  msGridUnit
} from './constants';
import { IHeaderTheme } from './SuiteHeader.types';

export const getStyles = (theme?: IHeaderTheme, customStyles?: IButtonStyles): IButtonStyles => {
  const backgroundColor = theme?.backgroundColor || defaultBackgroundColor;
  const foregroundColor = theme?.foregroundColor || defaultForegroundColor;

  const appBarButtonStyles: IButtonStyles = {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      lineHeight: '22px',
      padding: 0,
      minWidth: `${msGridUnit * 6}px`,
      height: `${msGridUnit * 6}px`,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: backgroundColor,
      color: foregroundColor,
      border: 'none',
      cursor: 'pointer',
      overflow: 'hidden',
      fontWeight: '600'
    },
    rootPressed: {
      color: hoverForegroundColor,
      backgroundColor: activeBackgroundColor,
      '.ms-Button-icon': {
        color: hoverForegroundColor,
        backgroundColor: activeBackgroundColor
      }
    },
    rootHovered: {
      color: hoverForegroundColor,
      backgroundColor: hoverBackgroundColor,
      '.ms-Button-icon': {
        color: hoverForegroundColor,
        backgroundColor: hoverBackgroundColor
      }
    }
  };

  return concatStyleSets(appBarButtonStyles, customStyles);
};
